export class MathUtils {

    public static roundWithTwoDecimals( figure: number ): number {
        return Math.round((figure + Number.EPSILON) * 100) / 100;
    }

}